import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/service_file_versions'
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      id_service_files: null,
      major: null,
      minor: null,
      patch: null,
      is_alpha: false,
      version_string: null,
      version_sort: null,
      prev_version_id: null,
      brief_description: null,
      release_notes: null,
      status: null,
      id_users: null,
      released: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    filterParams: {
      id_service_files: null,
      status: null,
      is_alpha: null,
      keywords: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_service_files: null,
        major: null,
        minor: null,
        patch: null,
        is_alpha: false,
        version_string: null,
        version_sort: null,
        prev_version_id: null,
        brief_description: null,
        release_notes: null,
        status: null,
        id_users: null,
        released: null,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const data = {
          where: {
            'service_file_versions.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, data)
          .then(response => {
            commit('SET_DATA_ITEM', response.data.data)
            commit('SET_LOADING', false)
            return response.data.data
          })
          .catch(error => console.error(error))
      }
      return false
    },
    saveData({ commit }, postData) {
      commit('SET_LOADING', true)
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data.status
        })
        .catch(error => console.error(error))
    },
  },
}
